import type { QueryClient } from "@tanstack/react-query";

/**
 * Invalidates all React Query caches related to reporting screens.
 *
 * Report queries currently use either:
 * - keys starting with `reports-` (clinic Reports page)
 * - keys ending with `-report` (ERP reports page)
 * - ad-hoc keys for dedicated report-like screens (e.g. ApplicationReport)
 */
export function invalidateReportsCache(queryClient: QueryClient): void {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const key0 = query.queryKey?.[0];
      if (
        key0 === "applications-with-appointments"
        || key0 === "application-stats"
        || key0 === "application-operations"
        || key0 === "application-analytics"
        || key0 === "application-report-scheduled-appointment-types"
        || key0 === "application-report-overdue-last-visits"
      ) {
        return true;
      }
      return (
        typeof key0 === "string" &&
        (key0.startsWith("reports-") || key0.endsWith("-report"))
      );
    },
  });
}
